export default "__VITE_ASSET__Csbe2hN5__"